// extracted by mini-css-extract-plugin
module.exports = {"previewHeader":"customize_previewHeader__12VSd"};